import React, { useState } from "react";
import "../styles/components/InfoAccordion.css";

const InfoAccordion = ({ trigger, children, defaultOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`info-accordion-widget ${isOpen ? "open" : ""}`}>
      <button
        className="info-accordion-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="bulb-icon">
          <svg
            className="bulb-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 3C8.7 3 6 5.7 6 9c0 2.2 1.2 4.1 3 5.2V17a1 1 0 001 1h4a1 1 0 001-1v-2.8c1.8-1.1 3-3 3-5.2 0-3.3-2.7-6-6-6Z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
            <path
              d="M9 21h6"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
            <path
              d="M10 17h4"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              opacity="0.5"
            />
          </svg>
          <svg
            className="spark-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2l1.4 4.3L17.7 5l-3.4 3.4L18 12l-3.7-1.6L12 16l-2.3-5.6L6 12l3.7-3.6L6.3 5l4.3 1.3L12 2Z"
              fill="var(--lp-accent, #4a5d4a)"
            />
            <circle cx="19" cy="5" r="1" fill="var(--lp-accent, #4a5d4a)" opacity="0.5" />
            <circle cx="5" cy="3" r="0.7" fill="var(--lp-accent, #4a5d4a)" opacity="0.3" />
            <circle cx="20" cy="14" r="0.7" fill="var(--lp-accent, #4a5d4a)" opacity="0.4" />
          </svg>
        </span>
        {trigger}
      </button>
      <div className="info-accordion-content">
        <div className="info-accordion-content-inner">
          <div className="info-accordion-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default InfoAccordion;
